import { Box, Column, Switch, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Links } from '~/constants';
import type { ISignUpFormValues } from '../../types';
import { PSA_DESCRIPTION } from '../constants';

export const PsaSection = () => {
  const { control } = useFormContext<ISignUpFormValues>();
  const workerType = useWatch({ control, name: 'workerType' });

  if (workerType !== 'employee') return null;

  return (
    <Box style={{ marginTop: 8, marginBottom: 4 }}>
      <Typography variant="subtitle1"
        as="h2"
       
        color={colors.neutral[600]}
        textAlign="center"
        style={{ margin: 0, marginBottom: 12 }}
      >
        Personnel Service Agreement
      </Typography>
      <Typography variant="body1" color={colors.neutral[600]} style={{ marginBottom: 28 }}>
        {PSA_DESCRIPTION}
      </Typography>
      <Controller
        name="psaAccepted"
        control={control}
        rules={{
          validate: (value, values) => values.workerType !== 'employee' || value === true,
        }}
        render={({ field }) => (
          <Column align="center" gap={1}>
            <Switch
              data-cy="switch-psa-accepted"
              checked={field.value}
              onChange={field.onChange}
              label={
                <Typography as="span" color={colors.neutral[600]}>
                  I agree to GoTu’s{' '}
                  <a
                    data-cy="link-psa"
                    href={Links.termsOfUseEmployee}
                    target="_blank"
                    rel="noopener noreferrer"
                    // stop the click from toggling the Switch this label belongs to
                    onClick={(e) => e.stopPropagation()}
                    style={{ color: colors.secondary[500], fontSize: 18, cursor: 'pointer' }}
                  >
                    Personnel Service Agreement
                  </a>
                </Typography>
              }
            />
          </Column>
        )}
      />
    </Box>
  );
};
